import { useRef, useState } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'

import { RECAPTCHA_SITE_KEY } from '../../../../constants/common'
import { useThemeMode } from '../../../../hooks'

import {
  useLoginFormPhoneSubmitHandlers,
  useLoginFormPhoneUserStatusSideEffects,
} from './LoginFormPhone.hooks'
import { isUserStatusValid } from './LoginFormPhone.utils'
import { LoginFormPhoneNumber } from './LoginFormPhoneNumber'
import { LoginFormPhoneVerification } from './LoginFormPhoneVerification'

function LoginFormPhone({
  onRemoveNotification,
  onSetNotification,
  onSuccessLogin,
}) {
  const [submittedPhoneData, setSubmittedPhoneData] = useState(null)
  const [userStatus, setUserStatus] = useState(null)

  const [isLoading, setLoading] = useState(false)

  const recaptchaRef = useRef(null)

  const { theme } = useThemeMode()

  const {
    handleResendCode,
    handleSubmitPhoneNumber,
    handleSubmitPhoneVerification,
  } = useLoginFormPhoneSubmitHandlers({
    recaptchaRef,
    setLoading,
    setSubmittedPhoneData,
    setUserStatus,
    submittedPhoneData,
    onRemoveNotification,
    onSetNotification,
    onSuccessLogin,
  })

  useLoginFormPhoneUserStatusSideEffects({
    userStatus,
  })

  function handleReturnBackToPhoneNumberForm() {
    setSubmittedPhoneData(null)
    setUserStatus(null)

    recaptchaRef.current?.reset()
  }

  return (
    <>
      {isUserStatusValid(userStatus) ? (
        <LoginFormPhoneVerification
          isLoading={isLoading}
          submittedPhoneData={submittedPhoneData}
          onRemoveNotification={onRemoveNotification}
          onResendCode={handleResendCode}
          onReturnBackToPhoneNumber={handleReturnBackToPhoneNumberForm}
          onSetNotification={onSetNotification}
          onSubmit={handleSubmitPhoneVerification}
        />
      ) : (
        <LoginFormPhoneNumber
          isLoading={isLoading}
          onRemoveNotification={onRemoveNotification}
          onSetNotification={onSetNotification}
          onSubmit={handleSubmitPhoneNumber}
        />
      )}
      <ReCAPTCHA
        // Google reads the theme only when the widget is created
        key={theme}
        ref={recaptchaRef}
        sitekey={RECAPTCHA_SITE_KEY}
        size='invisible'
        theme={theme}
      />
    </>
  )
}

export default LoginFormPhone
